import { z } from "zod";
import { phoneSchema } from "./common.js";
export const queueStatusSchema = z.enum([
    "WAITING",
    "CALLED",
    "SERVING",
    "COMPLETED",
    "NO_SHOW",
    "CANCELLED",
]);
export const checkInSchema = z.object({
    customerUid: z.string().min(1).optional(),
    customerName: z.string().min(1).max(120),
    customerPhone: phoneSchema.optional(),
    manifestId: z.string().min(1).max(64).optional(),
    bookingId: z.string().min(1).optional(),
    priority: z.number().int().min(0).max(10).optional(),
});
export const queueActionSchema = z.object({
    action: z.enum(["call", "serve", "complete", "no-show", "cancel"]),
});
export const checkInResponseSchema = z.object({
    id: z.string(),
    queueNumber: z.number(),
});
export const queueActionResponseSchema = z.object({ status: queueStatusSchema });
